// extracted by mini-css-extract-plugin
export default {"recos":"E1-z","productCardOverride":"F1-z","rowHasBadge":"G1-z"};